import React from 'react';
import {
  Dialog, DialogTitle, IconButton, styled, DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DialogWrapper = styled(Dialog)(({ theme }) => ({
  backdropFilter: 'blur(4px)',
}));

type ImageDialogProps = {
  children: React.ReactNode;
  handleClose: () => void;
  open: boolean;
}

function DialogPopup({
  children, handleClose, open,
}: ImageDialogProps) {
  return (
    <DialogWrapper onClose={handleClose} open={open} fullWidth maxWidth="lg">
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: '8px',
            top: '-10px',
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
    </DialogWrapper>
  );
}

export default DialogPopup;
